module.exports = __webpack_public_path__ + "img/calendar-tile.c8be9908.svg";